import { GenericTooltip } from "@components/tooltip-container";
import { useDesignElementManagerV2 } from "@hooks/use-design-element-manager";

import { type TileFilter } from "../types";

interface Props {
  filter: TileFilter;
  onClick: () => void;
}

export const QuickFilterButton = ({ filter, onClick }: Props) => {
  const { designElementManager } = useDesignElementManagerV2();

  return (
    <GenericTooltip
      noInfoCircle
      content={filter.value}
      overlayClassName="pointer-events-none"
      placement="top"
      mouseEnterDelay={500}
    >
      <div className="cursor-pointer rounded-full" onClick={onClick}>
        {designElementManager
          .getDesignElement(filter.value)
          .getComponent({ size: "30" })}
      </div>
    </GenericTooltip>
  );
};
